      // store.js
import { setStore, createStore } from "hooks-for-redux";
import { applyMiddleware } from "redux";

// example middle-ware
const logDispatch = store => next => action => {
  	return next(action);
};

export default setStore(createStore({}, applyMiddleware(logDispatch)));